import { Injectable, inject } from '@angular/core';
import {
  ServicemeshNavigationItem,
  ServicemeshNavigationService,
} from '@helpers/components/navigation';
import { ServicemeshMockApiService } from '@helpers/lib/mock-api';
import { defaultNavigation } from 'app/mock-api/common/navigation/data';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class SearchMockApi {
  private readonly _servicemeshMockApiService = inject(ServicemeshMockApiService);
  private readonly _servicemeshNavigationService = inject(ServicemeshNavigationService);

  private readonly _defaultNavigation: ServicemeshNavigationItem[] = defaultNavigation;

  /**
   * Constructor
   */
  constructor() {
    // Register Mock API handlers
    this.registerHandlers();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register Mock API handlers
   */
  registerHandlers(): void {
    // Get the flat navigation and store it
    const flatNavigation = this._servicemeshNavigationService.getFlatNavigation(
      this._defaultNavigation
    );

    // -----------------------------------------------------------------------------------------------------
    // @ Search results - GET
    // -----------------------------------------------------------------------------------------------------
    this._servicemeshMockApiService.onPost('api/common/search').reply(({ request }) => {
      // Get the search query
      const query = cloneDeep(request.body.query.toLowerCase());

      // If the search query is an empty string,
      // return an empty array
      if (query === '') {
        return [200, { results: [] }];
      }

      // Filter the navigation
      const pagesResults = cloneDeep(flatNavigation).filter(
        (page) =>
          page.title?.toLowerCase().includes(query) ||
          (page.subtitle && page.subtitle.includes(query))
      );

      // Prepare the results array
      const results = [];

      // If there are page results...
      if (pagesResults.length > 0) {
        // Normalize the results
        pagesResults.forEach((result: ServicemeshNavigationItem & { value?: string }) => {
          // Add the page title as the value
          result.value = result.title;
        });

        // Add to the results
        results.push({
          id: 'pages',
          label: 'Pages',
          results: pagesResults,
        });
      }

      // Return the response
      return [200, results];
    });
  }
}
